import { ContractTransaction } from '@ethersproject/contracts';
import Notify from 'bnc-notify';
import { bncDappId } from 'utils/config';
import { useCallback, useEffect, useState } from 'react';
import { getBlockExploreTxLink } from 'utils/networks';

const SUPPORTED_NETWORKS = [1, 3, 4, 5, 42, 56, 100, 137];

const uiOnlyMode = (networkId?: number) => {
  if (!networkId) return true;

  // if not supported, use ui only mode
  return !SUPPORTED_NETWORKS.includes(networkId);
};

const useTransactionHandler = (networkId?: number) => {
  const [notify, setNotify] = useState<any>(null);

  useEffect(() => {
    let notify;

    if (uiOnlyMode(networkId)) {
      // UI Only mode, acts as simple notification library
      notify = Notify({
        networkId,
        darkMode: true,
      });
    } else {
      notify = Notify({
        networkId,
        dappId: bncDappId,
        darkMode: true,
      });
    }

    setNotify(notify);
  }, [networkId]);

  const handleSuccess = useCallback(
    (res: ContractTransaction, cb: any = () => {}) => {
      if (uiOnlyMode(networkId)) {
        // basic notification library
        const link = getBlockExploreTxLink(res, networkId);
        console.log(link);

        const notificationObject = {
          eventCode: 'txPending',
          type: 'pending',
          message: `Transaction submitted! Refresh once confirmed.`,
          autoDismiss: 10000,
        };

        notify.notification(notificationObject);
      } else {
        // monitor transaction and respond to tx events (mined, dropped, etc)
        const { emitter } = notify.hash(res.hash);

        emitter.on('txConfirmed', (tx: any) => {
          console.log('tx:', tx);
          if (tx.status === 'confirmed') {
            const link = getBlockExploreTxLink(tx.hash, networkId);
            // Triggers success modal
            cb({ link, ...tx });
          }
          return {
            type: 'success',
            message:
              'Your transaction has succeeded. The UI may take a few moments to reflect these changes.',
            autoDismiss: 10000,
          };
        });
      }
    },
    [notify, networkId]
  );

  const handleError = useCallback(
    (message?: string) => {
      const notificationObject = {
        eventCode: 'txError',
        type: 'error',
        message: message || 'Something went wrong, your transaction was not submitted.',
        autoDismiss: 10000,
      };

      notify.notification(notificationObject);
    },
    [notify]
  );

  return {
    txHandler: handleSuccess,
    errorHandler: handleError,
  };
};

export default useTransactionHandler;
